import { createSelector } from "@reduxjs/toolkit";
import selectFiltersRaw from "./selectFiltersRaw";

export const categoryFiltersSelector = createSelector(
	selectFiltersRaw,
	(filters) => filters.membersWorkoutsSelectedCategories
);
export const equipmentFiltersSelector = createSelector(
	selectFiltersRaw,
	(filters) => filters.membersWorkoutsSelectedEquipment
);
export const trainerFiltersSelector = createSelector(
	selectFiltersRaw,
	(filters) => filters.membersWorkoutsSelectedTrainers
);

export const durationFiltersSelector = createSelector(
	selectFiltersRaw,
	(filters) => filters.membersWorkoutsSelectedDuration
);

export const musicFiltersSelector = createSelector(selectFiltersRaw, (filters) => filters.membersWorkoutsSelectedMusic);

